/* eslint-disable max-len */
var UI_SEARCH = {
  "default": 'M31.71,30.29l-8.84-8.84a13,13,0,1,0-1.42,1.42l8.84,8.84a1,1,0,0,0,1.42-1.42ZM5.22,20.78a11,11,0,1,1,15.56,0h0a11,11,0,0,1-15.55,0Z',
  globetrotter: 'M29.5 29.5L19.5 19.5M22.41 12.45C22.41 17.95 17.95 22.4 12.46 22.4C6.97 22.4 2.5 17.95 2.5 12.45C2.5 6.95 6.96 2.5 12.45 2.5C17.94 2.5 22.4 6.96 22.4 12.45H22.41Z'
};

export { UI_SEARCH };
//# sourceMappingURL=UI_SEARCH.js.map
